/**
 * Android emulator loopback is the guest, not the host machine.
 *
 * Fixtures tour covers live at `http://localhost:5055` on the laptop.
 * On this 16k AVD `adb reverse` does not publish extra ports on guest
 * 127.0.0.1, and `10.0.2.2:5055` is firewalled. Pass the host LAN IPv4
 * as `assetHost` so `:5055` stays and the AVD can reach the cover server.
 *
 * Physical devices keep localhost. Store builds never see these URLs.
 */

const LOOPBACK_ORIGIN = /^(https?):\/\/(localhost|127\.0\.0\.1)(?=[:/?#]|$)/i
const LOCAL_COVER_ORIGIN = /^(https?):\/\/(localhost|127\.0\.0\.1):5055(?=\/|$)/i

/**
 * Host IPv4 the AVD can reach for extra ports (covers on :5055).
 * `10.0.2.2:5055` is firewalled on this machine; the Wi-Fi LAN is not.
 * Override with EXPO_PUBLIC_ANDROID_EMU_HOST when the LAN changes.
 */
export function androidEmulatorAssetHost(
  os: string,
  isPhysicalDevice: boolean,
): string | undefined {
  if (os !== 'android' || isPhysicalDevice) return undefined
  const fromEnv =
    typeof process !== 'undefined' ? process.env.EXPO_PUBLIC_ANDROID_EMU_HOST?.trim() : undefined
  if (fromEnv) return fromEnv
  return '192.168.58.100'
}

export function metroOriginFromScriptURL(scriptURL: string | null | undefined): string | null {
  if (!scriptURL) return null
  try {
    const parsed = new URL(scriptURL)
    if (!parsed.protocol || !parsed.host) return null
    return `${parsed.protocol}//${parsed.host}`
  } catch {
    return null
  }
}

export function rewriteAndroidEmulatorLoopback(
  uri: string,
  options: {
    os: string
    isPhysicalDevice: boolean
    assetHost?: string
    metroOrigin?: string
  },
): string {
  if (options.os !== 'android' || options.isPhysicalDevice) return uri
  if (options.assetHost?.trim()) {
    return uri.replace(LOOPBACK_ORIGIN, `$1://${options.assetHost.trim()}`)
  }
  if (options.metroOrigin && LOCAL_COVER_ORIGIN.test(uri)) {
    return uri.replace(LOCAL_COVER_ORIGIN, `${options.metroOrigin.replace(/\/$/, '')}/tours-covers`)
  }
  return uri.replace(LOOPBACK_ORIGIN, '$1://10.0.2.2')
}
